
/*
* ぽちボタンクリック後の処理
*/ 

import applicationCMSClass from "./cms.class"

const ITZAI_PLAN = Object.freeze({
  recruitment: 'itzai_plan_recruitment',
  corporate: 'itzai_plan_corporate',
  complete: 'itzai_plan_complete',
})

const normalizeItzaiPlanId = (planId) => {
  return planId || ''
}

const isCorporateCompletePlanId = (planId) => {
  const pid = normalizeItzaiPlanId(planId)
  return pid === ITZAI_PLAN.corporate || pid === ITZAI_PLAN.complete
}

const isItzaiCorporateOnlyPlanId = (planId) => normalizeItzaiPlanId(planId) === ITZAI_PLAN.corporate

const isItzaiRecruitmentPlanId = (planId) => normalizeItzaiPlanId(planId) === ITZAI_PLAN.recruitment

export const isAnyItzaiProductChecked = ($) => $('#formItzaiSelect').prop('checked')

/** @deprecated イツザイ2.5廃止。常に false */
export const isItzai25ProductChecked = ($) => false

/** イツザイ（旧3.0相当） */
export const isItzaiProductChecked = ($) => $('#formItzaiSelect').prop('checked')

export const getItzaiProductLabel = () => 'イツザイ'

/** 受注内容・提案内容（シート列）用。旧2.5/3.0表記も「イツザイ」に正規化 */
export const toItzaiSheetProductName = (productName) => {
  if (productName === 'イツザイ2.5' || productName === 'イツザイ3.0' || productName === 'イツザイ') return 'イツザイ'
  return productName
}

/** シートの商材名から編集画面のチェックボックス data-name を復元（旧表記もイツザイへ） */
export const resolveItzaiCheckboxDataName = (sheetProductName) => {
  if (sheetProductName === 'イツザイ2.5' || sheetProductName === 'イツザイ3.0' || sheetProductName === 'イツザイ') {
    return 'イツザイ'
  }
  return sheetProductName
}

/** 追加オプション（チェック）を全文用文字列に整形 */
export const formatAdditionalOptions = (nameAttr) => {
  const vals = Array.from(
    document.querySelectorAll(`input[name="${nameAttr}"]:checked`)
  ).map((input) => input.value)
  return vals.length ? vals.join(' / ') : 'なし'
}

export const toItzaiSheetOrderContent = (orderContent) => {
  if (!orderContent) return ''
  return orderContent.split('+').map(toItzaiSheetProductName).join('+')
}

class afrPostItzai {
  constructor(that) {
    this.that = that
    this.formName = getItzaiProductLabel()
    const $ = this.that.$
    const store = this.that.store
    
    if(store.state.industryNamesData.length == 0) {
      this.that.vueObj.viewLoader('業界リスト読み込み中')
    }
    
    let i = 0
    const sit = setInterval(() => {
      
      if(store.state.industryNamesData.length > 0) {
        clearInterval(sit)
        this.that.vueObj.viewLoader()

        // データ出力先有無をチェック
        if($('#industry_names')[0]) {
          const industry_records = store.state.industryNamesData
          
          for(let i = 0; i < industry_records.length; i++) {
            let record = industry_records[i]
            let option = $('<option>')

            option.attr({
              id: 'jobsCategoriesID' + record.id,
              value: record.name,
              'data-id': record.id
            }).text(record.name)
            
            $('#industry_names').append(option).show()
          }

        }

      } else {
        i++
        if(i >= 200) {
          clearInterval(sit)
          alert('業界リストを取得できませんでした\nリロードします')
          window.location.reload()
        }
      }
      
    }, 50)


    this.that.$('.search_form_wrap').show()
    this.actionInit()
  }

  returnFormName() {
    return 'イツザイ'
  }

  getInputData () {
    const $ = this.that.$
    const moment = this.that.moment
    moment.locale("ja")
    const store = this.that.store
    const func = this.that.func

    const motiveSigningContractValue = Array.from(
      document.querySelectorAll('input[name="motive_signing_contract"]:checked')
    ).map(input => input.value)

    const persnalityValue = Array.from(
      document.querySelectorAll('input[name="persnality"]:checked')
    ).map(input => input.value)

    const promiseInsertionValue = Array.from(
      document.querySelectorAll('input[name="promise_insertion"]:checked')
    ).map(input => input.value)

    const promiseContentsValue = Array.from(
      document.querySelectorAll('input[name="promise_contents"]:checked')
    ).map(input => input.value)

    // 値取得：制作前共有
    store.commit('setValue', ['itzai', 'inputShouldMovie', $('[name="movie_yesNo"]:checked').val(), ''])
    store.commit('setValue', ['itzai', 'inputPlan', $('[name="itzai_plan"]:checked').val(), ''])
    store.commit('setValue', ['itzai', 'inputPRPagesProduced', func.textEscape($('#PR_pages_produced_itzai').val()), ''])
    store.commit('setValue', ['itzai', 'inputRequirementsProduced', func.textEscape($('#recruitment_requirements_produced_itzai').val()), ''])
    store.commit('setValue', ['itzai', 'inputJobSpecializedPages', func.textEscape($('#job_specialized_pages_itzai').val()), ''])
    store.commit('setValue', ['itzai', 'inputPaidAdCost', func.textEscape($('#paid_ad_cost').val()), ''])
    store.commit('setValue', ['itzai', 'inputRctJobCate', func.textEscape($('#rctJobCate').val()), ''])
    store.commit('setValue', ['itzai', 'inputOtherOp', formatAdditionalOptions('additional_options_itzai'), ''])
    store.commit('setValue', ['itzai', 'inputShouldShoot', $('[name="shoot_yesNo"]:checked').val(), ''])
    store.commit('setValue', ['itzai', 'inputReasonNotShoot', func.textEscape($("#reasonNotShoot").val()), ''])
    store.commit('setValue', ['itzai', 'inputMotiveSigningContract', motiveSigningContractValue, ''])
    store.commit('setValue', ['itzai', 'inputContractReason', func.textEscape($('#contractReason').val()), ''])
    store.commit('setValue', ['itzai', 'inputPersnality', persnalityValue, ''])
    store.commit('setValue', ['itzai', 'inputConv', func.textEscape($('#conv').val()), ''])
    store.commit('setValue', ['itzai', 'inputPromiseInsertion', promiseInsertionValue, ''])
    store.commit('setValue', ['itzai', 'inputConvItzai', func.textEscape($('#convItzai').val()), ''])
    store.commit('setValue', ['itzai', 'inputPromiseContents', promiseContentsValue, ''])
    store.commit('setValue', ['itzai', 'inputConvService', func.textEscape($('#convService').val()), ''])
    store.commit('setValue', ['itzai', 'inputShootDate', func.textEscape($('#shootDate').val()), ''])
    store.commit('setValue', ['itzai', 'inputRctBackground', func.textEscape($('#rctBackground').val()), ''])
    store.commit('setValue', ['itzai', 'inputKindPersonHope', func.textEscape($('#kind_person_Hope').val()), ''])
    store.commit('setValue', ['itzai', 'inputOtherHope', func.textEscape($('#otherHope').val()), ''])
    store.commit('setValue', ['itzai', 'inputContactItzai', func.textEscape($('#contact_itzai').val()), ''])
    store.commit('setValue', ['itzai', 'inputMainContactItzaiPresence', $('[name="main_contact_itzai_presence"]:checked').val(), ''])
    // store.commit('setValue', ['itzai', 'inputServiceContentItem1', func.textEscape($('#service_content_item1_itzai').val()), ''])
    // store.commit('setValue', ['itzai', 'inputServiceContentItem1Price', func.textEscape($('#service_content_item1_price_itzai').val()), ''])
    // store.commit('setValue', ['itzai', 'inputServiceContentItem2', func.textEscape($('#service_content_item2_itzai').val()), ''])
    // store.commit('setValue', ['itzai', 'inputServiceContentItem2Price', func.textEscape($('#service_content_item2_price_itzai').val()), ''])

    store.commit('setValue', ['itzai', 'inputBoostCampaign', $('[name="boost_campaign_itzai"]:checked').val(), ''])
    store.commit('setValue', ['itzai', 'inputContactCEOName', $("#contactCEOName").val(), ''])
    store.commit('setValue', ['itzai', 'inputIndustryName', $('#industry_names').val(), 'industry_name'])
    store.commit('setValue', ['itzai', 'inputIndustryDataId', $('#industry_names option:selected').data("id"), 'industry_data_id'])

  }

  setVal (balanceInfoMsg) {
    const store = this.that.store
    const $ = this.that.$
    const planId = normalizeItzaiPlanId($('[name="itzai_plan"]:checked').prop('id') || '')
    const hidePrItzai = isItzaiCorporateOnlyPlanId(planId)
    const showShootItzai = isItzaiRecruitmentPlanId(planId)
    const shootBlock = showShootItzai
      ? `撮影有無：${store.state.formData.itzai.inputShouldShoot}
撮影無し理由：${store.state.formData.itzai.inputReasonNotShoot}

`
      : ''

    const itzaiProductLabel = getItzaiProductLabel()
    const isMainItzai = isItzaiProductChecked($)
    const jobSpecializedPagesLine = isMainItzai
      ? `職種特化ページ追加数：${store.state.formData.itzai.inputJobSpecializedPages}

`
      : ''
    const prPagesLine = isMainItzai
      ? ''
      : `PRページ制作代行本数：${hidePrItzai ? '' : store.state.formData.itzai.inputPRPagesProduced}
`

    let sendVal = 
`
◎${itzaiProductLabel}
動画撮影：${store.state.formData.itzai.inputShouldMovie}
プラン：${store.state.formData.itzai.inputPlan}
${prPagesLine}募集要項制作代行数：${store.state.formData.itzai.inputRequirementsProduced}
${jobSpecializedPagesLine}初回広告費用：${store.state.formData.itzai.inputPaidAdCost}円

追加オプション：${store.state.formData.itzai.inputOtherOp}

募集業界：${store.state.formData.itzai.inputIndustryName}
募集職種名：${store.state.formData.itzai.inputRctJobCate}

${shootBlock}契約動機：${store.state.formData.itzai.inputMotiveSigningContract}
契約動機詳細：${store.state.formData.itzai.inputContractReason}

顧客人柄：${store.state.formData.itzai.inputPersnality}
お客様との会話内容：${store.state.formData.itzai.inputConv}

イツザイに載せる内容について話した内容：${store.state.formData.itzai.inputPromiseInsertion}
上記の詳細：${store.state.formData.itzai.inputConvItzai}

サービス内容について提案した内容：${store.state.formData.itzai.inputPromiseContents}
上記の詳細：${store.state.formData.itzai.inputConvService}

掲載希望日時：${store.state.formData.itzai.inputShootDate}
求人背景：${store.state.formData.itzai.inputRctBackground}
どういう人が取りたいか：${store.state.formData.itzai.inputKindPersonHope}
その他顧客希望：${store.state.formData.itzai.inputOtherHope}
広告費100万ブーストキャンペーンを適用しましたか？：${store.state.formData.itzai.inputBoostCampaign}
`
// サービス内容内訳項目1：${store.state.formData.itzai.inputServiceContentItem1}
// サービス内容金額1：${store.state.formData.itzai.inputServiceContentItem1Price}円
// サービス内容内訳項目2：${store.state.formData.itzai.inputServiceContentItem2}
// サービス内容金額2：${store.state.formData.itzai.inputServiceContentItem2Price}円

    const main_contact_yes_no = document.querySelector('input[name="main_contact_itzai"]:checked')
    if (main_contact_yes_no.value == "はい") {
      sendVal = sendVal + `
連絡先情報備考（主要窓口）：${store.state.formData.itzai.inputContactItzai}
商談同席有無：${store.state.formData.itzai.inputMainContactItzaiPresence}
`
    }

    store.commit('setTalknoteMessage', ['itzai', sendVal])
  }

  actionInit() {
    const $ = this.that.$
    const thatObj = this.that

    const syncAuxCmsFormVisibility = () => {
      const planId = normalizeItzaiPlanId($('[name="itzai_plan"]:checked').prop('id') || '')
      const isAuxTarget = isCorporateCompletePlanId(planId) && isAnyItzaiProductChecked($)

      if (isAuxTarget) {
        thatObj.vueObj.isFormApplicationCMS = true
        thatObj.vueObj.$nextTick(() => {
          $('#formCMS .form_wrap').show()
          if (!thatObj.appClassObj.cms) {
            thatObj.appClassObj.cms = new applicationCMSClass.afrPostCMS(thatObj)
          }
        })
      } else if (!$('#formCMSSelect').prop('checked')) {
        thatObj.vueObj.isFormApplicationCMS = false
        $('#formCMS .form_wrap').hide()
        thatObj.appClassObj.cms = null
      }
    }

    const syncItzaiJobSpecializedPagesVisibility = () => {
      const isMainItzai = isItzaiProductChecked($)
      const $input = $('#job_specialized_pages_itzai')
      const $col = $('#itzai_job_specialized_pages_col')

      if (isMainItzai) {
        $col.slideDown()
        $input.addClass('required')
      } else {
        $col.slideUp()
        $input.removeClass('required').val('')
      }
    }

    const syncCorporatePrShootVisibility = () => {
      const planId = normalizeItzaiPlanId($('[name="itzai_plan"]:checked').prop('id') || '')
      const hidePr = isItzaiCorporateOnlyPlanId(planId) || isItzaiProductChecked($)
      const showShoot = isItzaiRecruitmentPlanId(planId)
      const $prInput = $('#PR_pages_produced_itzai')
      const $prCol = $prInput.closest('.pd3_parts')
      const $shootCol = $('#shoot_yes').closest('.pd3_parts')
      const $reasonCol = $('#fildReasonNotShoot')
      const $reasonInput = $('#reasonNotShoot')

      if (hidePr) {
        $prCol.slideUp()
        $prInput.removeClass('required').val('')
      } else {
        $prCol.slideDown()
        $prInput.addClass('required')
      }

      if (!showShoot) {
        $shootCol.slideUp()
        $('[name="shoot_yesNo"]').prop('checked', false).removeClass('required')
        $reasonCol.addClass('-none').hide()
        $reasonInput.removeClass('required').val('')
      } else {
        $shootCol.slideDown()
        $('[name="shoot_yesNo"]').addClass('required')
        $reasonCol.addClass('-none').hide()
        $reasonInput.removeClass('required').val('')
      }
    }
    
    $("#form_ap").on("click", '[name="shoot_yesNo"]', function() {
      
      let thisVal = $(this).prop("id")

      switch (thisVal) {
        case "shoot_yes":
          $("#fildReasonNotShoot").slideUp()
          $("#reasonNotShoot").removeClass("required")
          $("#reasonNotShoot").val("")
          break;
      
        case "shoot_no":
          $("#fildReasonNotShoot").slideDown()
          $("#reasonNotShoot").addClass("required")
          break;
      }
    })

    $("#form_ap").on("change", '#formItzaiSelect', function() {
      syncItzaiJobSpecializedPagesVisibility()
      syncCorporatePrShootVisibility()
    })

    $("#form_ap").on("change", '[name="itzai_plan"]', function() {
      syncAuxCmsFormVisibility()
      syncCorporatePrShootVisibility()
    })

    $("#form_ap").on("change", '[name="main_contact_itzai"]', function() {

      let thisVal = $(this).prop("id")

      switch (thisVal) {
        case "main_contact_itzai_no":
          $("#is_contact_itzai_concurrent, #is_contact_itzai_presence").slideUp()
          $("#contact_itzai, [name='main_contact_itzai_presence']").removeClass("required")
          $("#contact_itzai").val("")
          $("[name='main_contact_itzai_presence']").prop("checked", false)
          break;

        case "main_contact_itzai_yes":
          $("#is_contact_itzai_concurrent, #is_contact_itzai_presence").slideDown()
          $("#contact_itzai, [name='main_contact_itzai_presence']").addClass("required")
          break;
      }
    })

    syncAuxCmsFormVisibility()
    syncCorporatePrShootVisibility()
    syncItzaiJobSpecializedPagesVisibility()
  }

/*  setParams() {
    const $ = this.that.$
    const vueObj = this.that.vueObj
    const props = this.that.props
    const func = this.that.func
    const store = this.that.store
    const getDataApiURL = this.that.getDataApiURL

    let params = {
      //msg: store.state.msg,
      contact_com_name: this.values.inputContactComName,
      contact_name: this.values.inputContactName,
      contact_mail: this.values.inputContactMail,
      contact_tel_num: this.values.inputContactTelNum,
    };

    return params
  } */
}

export default {
  afrPostItzai,
  formatAdditionalOptions,
  getItzaiProductLabel,
  toItzaiSheetProductName,
  resolveItzaiCheckboxDataName,
  isAnyItzaiProductChecked,
  isItzaiProductChecked,
}